import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-teal-600 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center">
                <i className="ri-line-chart-line text-2xl text-teal-600"></i>
              </div>
              <span className="text-lg font-bold leading-tight text-white">
                CEB Consulting Inc.
              </span>
            </div>
            <p className="text-teal-50 leading-relaxed">
              20+ years of consulting excellence, helping businesses solve complex challenges and achieve sustainable growth.
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4">Services</h3>
            <ul className="space-y-2">
              <li><Link to="/services#business-strategy" className="text-teal-50 hover:text-white transition-colors cursor-pointer">Business Strategy</Link></li>
              <li><Link to="/services#market-analysis" className="text-teal-50 hover:text-white transition-colors cursor-pointer">Market Analysis</Link></li>
              <li><Link to="/services#pricing-strategy" className="text-teal-50 hover:text-white transition-colors cursor-pointer">Pricing Strategy</Link></li>
              <li><Link to="/services#growth-consulting" className="text-teal-50 hover:text-white transition-colors cursor-pointer">Growth Consulting</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-xl flex-shrink-0"></i>
                <span className="text-teal-50">5915 Leslie St<br />North York, ON M2H 1J8</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-phone-line text-xl"></i>
                <span className="text-teal-50">437-602-7683</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-mail-line text-xl"></i>
                <span className="text-teal-50">info@cebconsultinginc.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-teal-500 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-teal-50 text-sm">
            © 2025 CEB Consulting Inc. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm">
            <Link to="/privacy-policy" className="text-teal-50 hover:text-white transition-colors cursor-pointer">Privacy Policy</Link>
            <Link to="/terms-of-service" className="text-teal-50 hover:text-white transition-colors cursor-pointer">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
